/**
 * Skobo Permission class
 * @category Models
 * @subcategory Documents
 * @class ConfidentialFolder
 * @name ConfidentialFolder
 */

export default class ConfidentialFolder {
  confidentialFolderId; // <-- valid only inside class (and requires class fields support)
  name = {
    title: null,
    name: "",
    firstName: "",
    lastName: ""
  };
  userId;
  sectionId;
  action;
  targets;
  driveId;
  itemId;
  sectionDisplayName;
  userDisplayName;
  verifiedDate;
  archiveReadyDate;
  obs;
  extSysApiUserId;
  accessUntil;
  softDeleted;
  transferStatus;

  constructor(apiConfidentialFolder) {
    if (!apiConfidentialFolder) return;

    if (apiConfidentialFolder.confidentialId) {
      this.confidentialFolderId = apiConfidentialFolder.confidentialId;
    } else {
      this.confidentialFolderId = apiConfidentialFolder.id;
    }

    if (apiConfidentialFolder.userDisplayName) {
      const cleanedName = (
        apiConfidentialFolder.userDisplayName.indexOf("(") > -1
          ? apiConfidentialFolder.userDisplayName.substring(0, apiConfidentialFolder.userDisplayName.indexOf("("))
          : apiConfidentialFolder.userDisplayName
      ).trim();

      const nameSplit = cleanedName.split(" ");
      if (nameSplit.length > 1) {
        this.name = {
          title: null,
          name: cleanedName,
          lastName: nameSplit[nameSplit.length - 1],
          firstName: nameSplit.slice(0, nameSplit.length - 1).join(" ")
        };
      } else {
        this.name = {
          title: null,
          name: cleanedName,
          firstName: nameSplit[0],
          lastName: ""
        };
      }
    } else if (typeof apiConfidentialFolder.name === "string") {
      const cleanedName = (
        apiConfidentialFolder.name.indexOf("(") > -1
          ? apiConfidentialFolder.name.substring(0, apiConfidentialFolder.name.indexOf("("))
          : apiConfidentialFolder.name
      ).trim();

      const nameSplit = cleanedName.split(" ");
      if (nameSplit.length > 1) {
        this.name = {
          title: null,
          name: cleanedName,
          lastName: nameSplit[nameSplit.length - 1],
          firstName: nameSplit.slice(0, nameSplit.length - 1).join(" ")
        };
      } else {
        this.name = {
          title: null,
          name: cleanedName,
          firstName: nameSplit[0],
          lastName: ""
        };
      }
    } else {
      this.name = apiConfidentialFolder.name;
    }
    this.userId = apiConfidentialFolder.userId;
    this.sectionId = apiConfidentialFolder.sectionId;
    this.action = apiConfidentialFolder.action;
    this.targets = (apiConfidentialFolder.targets || [])
      .slice()
      .sort((a, b) => a.institutionDisplayName.localeCompare(b.institutionDisplayName));
    this.verifiedDate = apiConfidentialFolder.verifiedDateTime || apiConfidentialFolder.verified;
    this.driveId = apiConfidentialFolder.driveId;
    this.itemId = apiConfidentialFolder.itemId;
    this.archiveReadyDate = apiConfidentialFolder.archiveReady;
    this.sectionDisplayName = apiConfidentialFolder.sectionDisplayName;
    this.userDisplayName = apiConfidentialFolder.userDisplayName;
    this.obs = apiConfidentialFolder.obs;
    this.extSysApiUserId = apiConfidentialFolder.extSysApiUserId;
    this.accessUntil = apiConfidentialFolder.accessUntil;
    this.softDeleted = apiConfidentialFolder.softDeleted;
    this.transferStatus = apiConfidentialFolder.transferStatus;
  }

  // Getters
  /**
   * DriveItems parentReference object
   * @returns {object} parentReference object with driveId
   */
  get parentReference() {
    return {
      driveId: this.driveId
    };
  }

  /**
   * DriveItems id
   * @returns {string} Drive item id
   */
  get id() {
    return this.itemId;
  }

  get targetsAsString() {
    return this.targets.map(t => t.institutionDisplayName).join(", ") || null;
  }
}
